import React, { useEffect, useState } from "react";
import instance from "../../api/api";
import InputCreate from "../../features/InputCreate";

import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useParams } from "react-router-dom";
import Button from "../../features/Button";
// import { FaArrowLeft } from "react-icons/fa";
import { Upload } from "antd";
import SelectCommodite from "./feature/SelectCommodite";
import { Header, LoadingSpinner } from "../../shared/compoments";
const SharedCompoment = ({
  dataBien,
  setDataBien,
  fileList,
  onChangeForGalerie,
  onPreview,
  allMunicipalite,
  allTypes,
}) => {
  return (
    <div className="row">
      <div className="col-lg-4">
        <InputCreate
          label="Lieu"
          typeInput="text"
          nameInput="lieu"
          active={true}
          getValue={(e) => {
            setDataBien({ ...dataBien, adresse: e.target.value });
          }}
          dataValue={dataBien.adresse}
        />
      </div>

      <div className="col-lg-4">
        <label htmlFor="commune" className="fw-bold">
          Communes
        </label>
        <select
          name="commune"
          id="all_categorie"
          defaultValue={""}
          onChange={(e) => {
            setDataBien({ ...dataBien, municipality_id: e.target.value });
          }}
          className="form-select p-3 mb-2">
          <option value={""} disabled>
            Sélectionner une commune
          </option>
          {allMunicipalite.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
      </div>

      <div className="col-lg-4">
        <label htmlFor="types" className="fw-bold">
          Types
        </label>
        <select
          name="types"
          id="all_Types"
          defaultValue={""}
          onChange={(e) => {
            setDataBien({ ...dataBien, type_id: e.target.value });
          }}
          className="form-select p-3 mb-2">
          <option value={""} disabled>
            Sélectionner un type
          </option>
          {allTypes.map((item) => (
            <option key={item.id} value={item.id}>
              {item.label}
            </option>
          ))}
        </select>
      </div>

      <div className="col-lg-12">
        <label htmlFor="description" className="fw-bold">
          Description
        </label>
        <textarea
          value={dataBien.description}
          onChange={(e) => {
            setDataBien({ ...dataBien, description: e.target.value });
          }}
          name="description"
          cols="30"
          rows="5"
          className="form-control w-100"></textarea>
      </div>

      <div className="col-lg-4">
        <InputCreate
          label="Prix (Fcfa)"
          typeInput="number"
          nameInput="Prix"
          active={true}
          getValue={(e) => {
            setDataBien({ ...dataBien, cost: e.target.value });
          }}
          dataValue={dataBien.cost}
        />
      </div>

      <div className="col-lg-8">
        <fieldset className="border rounded p-3">
          <legend className="fw-bold">Documents</legend>
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(event) =>
                    setDataBien({
                      ...dataBien,
                      declaration_impots: event.target.checked,
                    })
                  }
                />
              }
              label="Déclarer au impôt"
            />
          </div>
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(event) =>
                    setDataBien({
                      ...dataBien,
                      ACD: event.target.checked,
                    })
                  }
                />
              }
              label="ACD"
            />
          </div>
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(event) =>
                    setDataBien({
                      ...dataBien,
                      attestation_villageoise: event.target.checked,
                    })
                  }
                />
              }
              label="Attestation villageoise"
            />
          </div>
          {dataBien.messageError && (
            <span className="text-danger">
              Veuillez cocher une de ces options
            </span>
          )}
        </fieldset>
      </div>

      <div className="col-lg-12 my-3">
        <label className="w-100 my-2 fw-bold">Ajouter vos photos</label>
        <Upload
          listType="picture-card"
          fileList={fileList}
          onChange={onChangeForGalerie}
          onPreview={onPreview}
          multiple>
          {fileList.length < 5 && "+ Ajouter vos photos"}
        </Upload>
      </div>
    </div>
  );
};

// const SharedCompoment = ({
//   dataBien,
//   setDataBien,
//   fileList,
//   onChangeForGalerie,
//   onPreview,
//   allMunicipalite,
//   allTypes,
// }) => {
//   return (
//     <>
//       <InputCreate
//         label="Lieu"
//         typeInput="text"
//         nameInput="lieu"
//         active={true}
//         getValue={(e) => {
//           setDataBien({ ...dataBien, adresse: e.target.value });
//         }}
//         dataValue={dataBien.adresse}
//       />
//       <div>
//         <label htmlFor="commune">Communes</label>
//         <select
//           name="commune"
//           id="all_categorie"
//           defaultValue={""}
//           onChange={(e) => {
//             setDataBien({ ...dataBien, municipality_id: e.target.value });
//           }}
//           className="w-100 p-3 mb-2">
//           <option value={""} disabled>
//             Sélectionner une commune
//           </option>
//           {allMunicipalite.map((item) => (
//             <option key={item.id} value={item.id}>
//               {item.name}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div>
//         <label htmlFor="types">Types</label>
//         <select
//           name="types"
//           id="all_Types"
//           defaultValue={""}
//           onChange={(e) => {
//             setDataBien({ ...dataBien, type_id: e.target.value });
//           }}
//           className="w-100 p-3 mb-2">
//           <option value={""} disabled>
//             Sélectionner un type
//           </option>
//           {allTypes.map((item) => (
//             <option key={item.id} value={item.id}>
//               {item.label}
//             </option>
//           ))}
//         </select>
//       </div>
//       <div>
//         <label htmlFor="description">Description</label>
//         <textarea
//           value={dataBien.description}
//           onChange={(e) => {
//             setDataBien({ ...dataBien, description: e.target.value });
//           }}
//           name="description"
//           id=""
//           cols="30"
//           rows="10"
//           className="w-100"></textarea>
//       </div>
//       <InputCreate
//         label="Prix (Fcfa)"
//         typeInput="number"
//         nameInput="Prix"
//         active={true}
//         getValue={(e) => {
//           setDataBien({ ...dataBien, cost: e.target.value });
//         }}
//         dataValue={dataBien.cost}
//       />
//       <fieldset>
//         <legend>Documents</legend>
//         <div>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 onChange={(event) =>
//                   setDataBien({
//                     ...dataBien,
//                     declaration_impots: event.target.checked,
//                   })
//                 }
//               />
//             }
//             label="Déclarer au impot"
//           />
//         </div>
//         <div>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 onChange={(event) =>
//                   setDataBien({
//                     ...dataBien,
//                     ACD: event.target.checked,
//                   })
//                 }
//               />
//             }
//             label="ACD"
//           />
//         </div>
//         <div>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 onChange={(event) =>
//                   setDataBien({
//                     ...dataBien,
//                     attestation_villageoise: event.target.checked,
//                   })
//                 }
//               />
//             }
//             label="Attestation villageoise"
//           />
//         </div>
//         {dataBien.messageError && (
//           <span className="text-danger">
//             Veuillez-cocher une de ces options
//           </span>
//         )}
//       </fieldset>
//       <label className="w-100 my-3">Ajouter vos photos</label>
//       <Upload
//         listType="picture-card"
//         fileList={fileList}
//         onChange={onChangeForGalerie}
//         onPreview={onPreview}
//         multiple>
//         {fileList.length < 5 && "+ Ajouter vos photos"}
//       </Upload>
//     </>
//   );
// };

const CreateMaison = ({
  dataBien,
  setDataBien,
  commodites,
  setCommodites,
  fileList,
  onChangeForGalerie,
  onPreview,
  allMunicipalite,
  allTypes,
}) => {
  return (
    <div className="row">
      <div className="col-lg-4">
        {commodites.length > 0 && (
          <div className="py-3">
            <label htmlFor="commodite" className="py-2 fw-bold">
              Commodités
            </label>
            <SelectCommodite
              commodites={commodites}
              setCommodites={setCommodites}
            />
          </div>
        )}

        {dataBien.type_de_transaction !== "EN VENTE" && (
          <InputCreate
            label="Caution (Nombre de mois)"
            typeInput="number"
            minValueInput={1}
            nameInput="Caution"
            active={true}
            getValue={(e) => {
              const value = e.target.value;
              setDataBien((prev) => ({ ...prev, caution: value }));
            }}
            dataValue={dataBien.caution}
          />
        )}

        <InputCreate
          label="Nombre de pièces"
          typeInput="number"
          minValueInput={1}
          nameInput="Nombre de pièces"
          active={true}
          getValue={(e) => {
            const value = e.target.value;
            setDataBien((prev) => ({ ...prev, nombre_pieces: value }));
          }}
          dataValue={dataBien.nombre_pieces}
        />

        <InputCreate
          label="Nombre de portes"
          typeInput="number"
          minValueInput={1}
          nameInput="Nombre de portes"
          active={true}
          getValue={(e) => {
            const value = e.target.value;
            setDataBien((prev) => ({ ...prev, nombre_portes: value }));
          }}
          dataValue={dataBien.nombre_portes}
        />
      </div>

      <SharedCompoment
        dataBien={dataBien}
        setDataBien={setDataBien}
        fileList={fileList}
        onChangeForGalerie={onChangeForGalerie}
        onPreview={onPreview}
        allMunicipalite={allMunicipalite}
        allTypes={allTypes}
      />
    </div>
  );
};

// const CreateMaison = ({
//   dataBien,
//   setDataBien,
//   commodites,
//   setCommodites,
//   fileList,
//   onChangeForGalerie,
//   onPreview,
//   allMunicipalite,
//   allTypes,
// }) => {
//   return (
//     <>
//       {commodites.length > 0 && (
//         <div className="py-3">
//           <label htmlFor="commodite fw-bold" className="py-2">
//             Commodités
//           </label>
//           <SelectCommodite
//             commodites={commodites}
//             setCommodites={setCommodites}
//           />
//         </div>
//       )}

//       {dataBien.type_de_transaction !== "EN VENTE" && (
//         <InputCreate
//           label="Caution (Nombre de mois)"
//           typeInput="number"
//           minValueInput={1}
//           nameInput="Caution"
//           active={true}
//           getValue={(e) => {
//             setDataBien({ ...dataBien, caution: e.target.value });
//           }}
//           dataValue={dataBien.caution}
//         />
//       )}
//       <InputCreate
//         label="Nombre de pièces"
//         typeInput="number"
//         minValueInput={1}
//         nameInput="Nombre de pièces"
//         active={true}
//         getValue={(e) => {
//           setDataBien({ ...dataBien, nombre_pieces: e.target.value });
//         }}
//         dataValue={dataBien.nombre_pieces}
//       />
//       <InputCreate
//         label="Nombre de portes"
//         typeInput="number"
//         minValueInput={1}
//         nameInput="Nombre de portes"
//         active={true}
//         getValue={(e) => {
//           setDataBien({ ...dataBien, nombre_portes: e.target.value });
//         }}
//         dataValue={dataBien.nombre_portes}
//       />
//       <SharedCompoment
//         dataBien={dataBien}
//         setDataBien={setDataBien}
//         fileList={fileList}
//         onChangeForGalerie={onChangeForGalerie}
//         onPreview={onPreview}
//         allMunicipalite={allMunicipalite}
//         allTypes={allTypes}
//       />
//     </>
//   );
// };

const CreatedTerrain = ({
  dataBien,
  setDataBien,
  fileList,
  onChangeForGalerie,
  onPreview,
  allMunicipalite,
  allTypes,
}) => {
  return (
    <div className="row">
      <div className="col-lg-12">
        <InputCreate
          label="Superficie (m2)"
          typeInput="number"
          minValueInput={1}
          nameInput="Superficie"
          active={true}
          getValue={(e) => {
            setDataBien({ ...dataBien, superficie: e.target.value });
          }}
          dataValue={dataBien.superficie}
        />
      </div>

      <SharedCompoment
        dataBien={dataBien}
        setDataBien={setDataBien}
        fileList={fileList}
        onChangeForGalerie={onChangeForGalerie}
        onPreview={onPreview}
        allMunicipalite={allMunicipalite}
        allTypes={allTypes}
      />
    </div>
  );
};

function CreateBiens() {
  const { id } = useParams();
  const styleBtn = {
    padding: ".5em",
    borderRadius: "5px",
    fontWeight: "bold",
    cursor: "pointer",
    color: "black",
    backgroundColor: "rgb(255 177 47 / 99%)",
    marginTop: "1em",
    border: "none",
  };
  const MySwal = withReactContent(Swal);
  const [nameOfPerson, setNameOfPerson] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingAllProduction, setIsLoadingAllProduction] = useState(true);
  const [allTypes, setAllTypes] = useState([]);
  const [allCategorie, setAllCategorie] = useState([]);
  const [commodites, setCommodites] = useState([]);
  const [allMunicipalite, setAllMunicipalite] = useState([]);
  const [allProprietaire, setAllProprietaire] = useState([]);
  const [dataBien, setDataBien] = useState({
    nom: "",
    cost: "",
    adresse: "",
    superficie: "",
    caution: "",
    description: "",
    municipality_id: "",
    category_libelle: "Terrain",
    nombre_pieces: "",
    nombre_portes: "",
    type_id: "",
    proprietaire_id: "",
    statut: "Disponible",
    type_de_transaction: "EN VENTE",
    declaration_impots: true,
    attestation_villageoise: false,
    ACD: false,
    messageError: false,
  });
  const [fileList, setFileList] = useState([]);
  const verifIsPapierOrDeclarationImpot = () => {
    let element = false;
    console.log({
      declaration: dataBien.declaration_impots,
      acd: dataBien.ACD,
      attestation_vill: dataBien.attestation_villageoise,
    });
    if (
      !dataBien.declaration_impots &&
      !dataBien.ACD &&
      !dataBien.attestation_villageoise
    ) {
      element = true;
    }
    console.log(element);
    return element;
  };

  const getAllCommoditeWithNumber = (valueArray) => {
    let addValueAndNameCommodite = [];
    valueArray.forEach((item) => {
      addValueAndNameCommodite.push({
        comodity_id: item.id,
        number: item.number,
      });
    });
    return addValueAndNameCommodite;
  };

  const saveProprieteProprietaire = async (e) => {
    e.preventDefault();
    const isResquetPapierIsCorrect = verifIsPapierOrDeclarationImpot();
    console.log(isResquetPapierIsCorrect);
    if (isResquetPapierIsCorrect) {
      setDataBien({ ...dataBien, messageError: true });
    } else {
      dataBien.messageError = false;
      setIsLoading(true);

      try {
        const formData = new FormData();
        const tableauImage = convertirGalerie(fileList);
        for (const element in tableauImage) {
          formData.append("path[]", tableauImage[element]);
        }
        const COMMODITES_WITH_INFO = getAllCommoditeWithNumber(commodites);
        console.log("COMMODITES_WITH_INFO", COMMODITES_WITH_INFO);

        formData.append("cost", dataBien.cost);
        formData.append("adresse", dataBien.adresse);
        formData.append("superficie", dataBien.superficie);
        formData.append("caution", dataBien.caution);
        formData.append("description", dataBien.description);
        formData.append("municipality_id", dataBien.municipality_id);
        formData.append("nombre_pieces", dataBien.nombre_pieces);
        formData.append("nombre_portes", dataBien.nombre_portes);
        formData.append("type_id", dataBien.type_id);
        formData.append(
          "comodites",
          dataBien.category_libelle === "Terrain" ? null : COMMODITES_WITH_INFO
        );
        formData.append("proprietaire_id", !id ? dataBien.proprietaire_id : id);
        formData.append("nom", dataBien.nom);
        formData.append(
          "declaration_impots",
          dataBien.declaration_impots ? "oui" : "non"
        );
        formData.append("ACD", dataBien.ACD ? "oui" : "non");
        formData.append(
          "attestation_villageoise",
          dataBien.attestation_villageoise ? "oui" : "non"
        );
        formData.append("type_de_transaction", dataBien.type_de_transaction);
        const response = await instance.post("proprieties", formData);

        console.log(response);
        if (!response.data.status) {
          setIsLoading(false);
          let msgError = [];
          for (const property in response.data.message) {
            msgError = [...msgError, response.data.message[property]];
          }
          MySwal.fire({
            title: msgError,
            icon: "info",
            showConfirmButton: true,
          });
        } else {
          setIsLoading(false);
          resetDataBien();
          dataBien.declaration_impots = false;
          dataBien.ACD = false;
          dataBien.attestation_villageoise = false;
          onChangeForGalerie({ fileList: [] });
          MySwal.fire({
            title: "Enregistrement reussi.",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } catch (error) {
        console.log(error);
        let msgError = [];
        for (const property in error.response.data.message) {
          msgError = [...msgError, error.response.data.message[property]];
        }
        MySwal.fire({
          title: msgError,
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoading(false);
      }
    }
  };
  const resetDataBien = () => {
    setDataBien({
      nom: "",
      cost: "",
      adresse: "",
      superficie: "",
      caution: "",
      description: "",
      municipality_id: "",
      category_libelle: "Terrain",
      nombre_pieces: "",
      nombre_portes: "",
      type_id: "",
      proprietaire_id: "",
      statut: "Disponible",
      type_de_transaction: "EN VENTE",
      declaration_impots: false,
      attestation_villageoise: false,
      ACD: false,
      messageError: false,
    });
  };
  const onChangeForGalerie = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  const convertirGalerie = (tableauImage) => {
    let newTableau = [];
    tableauImage.forEach((item) => {
      newTableau.push(item.originFileObj);
    });
    return newTableau;
  };
  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };
  const getNameOfPersonn = (element) => {
    const { nom, prenom } = element.find(
      (item) => Number(item.id) === Number(id)
    );
    return `${nom} ${prenom}`;
  };

  useEffect(() => {
    const listerAll = async () => {
      const responseTypes = await instance.get("types");
      const responseMunicipalite = await instance.get("municipalite");
      const responseCategorie = await instance.get("categories");
      const responseProprietaire = await instance.get("prorietaires");
      const responseCommodite = await instance.get("comodites");

      setCommodites(
        responseCommodite?.data?.data.map((item) => ({
          ...item,
          checked: false,
          number: 0,
        }))
      );
      setAllTypes(responseTypes?.data?.data);
      setAllCategorie(responseCategorie?.data?.data);
      setAllMunicipalite(responseMunicipalite?.data?.data);
      setAllProprietaire(responseProprietaire?.data?.data);
      setIsLoadingAllProduction(false);
      console.log("responseTypes", responseTypes);
      console.log("responseMunicipalite", responseMunicipalite);
      console.log("responseCategorie", responseCategorie);
    };
    listerAll();
  }, []);

  if (isLoadingAllProduction) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      <Header
        libelle={
          id
            ? `Enregistre un bien pour : ${getNameOfPersonn(allProprietaire)}`
            : "Enregistrer un bien"
        }
      />
      <form onSubmit={saveProprieteProprietaire} className="my-3 px-3">
        <div className="row">
          <div className="col-lg-6 col-md-6">
            <label htmlFor="categorie">Catégorie</label>
            <select
              name="transactions"
              id="categorie"
              defaultValue={dataBien.category_libelle}
              onChange={(e) => {
                setDataBien({ ...dataBien, category_libelle: e.target.value });
              }}
              className="form-control p-3">
              <option value={""} disabled>
                Sélectionner une catégorie
              </option>
              {allCategorie.map((item) => (
                <option key={item.id} value={item.label}>
                  {item?.label}
                </option>
              ))}
            </select>
          </div>

          {!id && (
            <div className="col-lg-6 col-md-6 mb-3">
              <label htmlFor="commune">Propriétaire</label>
              <select
                name="commune"
                id="all_categorie"
                defaultValue={dataBien.proprietaire_id}
                onChange={(e) => {
                  setDataBien({ ...dataBien, proprietaire_id: e.target.value });
                }}
                className="form-control p-3">
                <option value="" disabled>
                  Sélectionner un propriétaire
                </option>
                {allProprietaire.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.nom} {item.prenom}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="col-lg-6 col-md-6">
            <InputCreate
              label="Bien"
              typeInput="text"
              nameInput="Nom"
              active={true}
              getValue={(e) => {
                setDataBien({ ...dataBien, nom: e.target.value });
              }}
              dataValue={dataBien.nom}
            />
          </div>

          <div className="col-lg-6 col-md-6">
            <label htmlFor="type_transaction">Type de transaction</label>
            <select
              name="transactions"
              id="type_transaction"
              defaultValue={dataBien.type_de_transaction}
              onChange={(e) => {
                setDataBien({
                  ...dataBien,
                  type_de_transaction: e.target.value,
                });
              }}
              className="form-control p-3">
              <option value={""} disabled>
                Sélectionner un type
              </option>
              <option value="EN VENTE">En vente</option>
              <option value="EN LOCATION">En location</option>
            </select>
          </div>

          <div className="col-12">
            {dataBien.category_libelle === "Terrain" &&
              dataBien.type_de_transaction === "EN VENTE" && (
                <CreatedTerrain
                  dataBien={dataBien}
                  setDataBien={setDataBien}
                  fileList={fileList}
                  onChangeForGalerie={onChangeForGalerie}
                  onPreview={onPreview}
                  allMunicipalite={allMunicipalite}
                  allTypes={allTypes}
                />
              )}
            {dataBien.category_libelle === "Terrain" &&
              dataBien.type_de_transaction === "EN LOCATION" && (
                <h6 className="text-center text-danger">
                  Cette option n'est pas encore disponible
                </h6>
              )}
            {dataBien.category_libelle === "Maison" &&
              (dataBien.type_de_transaction === "EN LOCATION" ||
                dataBien.type_de_transaction === "EN VENTE") && (
                <CreateMaison
                  dataBien={dataBien}
                  setDataBien={setDataBien}
                  commodites={commodites}
                  setCommodites={setCommodites}
                  fileList={fileList}
                  onChangeForGalerie={onChangeForGalerie}
                  onPreview={onPreview}
                  allMunicipalite={allMunicipalite}
                  allTypes={allTypes}
                />
              )}
          </div>

          <div className="col-12 text-center mt-4">
            <Button
              titre="Enregistrer"
              styleBtn={styleBtn}
              isLoading={isLoading}
            />
          </div>
        </div>
      </form>

      {/* <form onSubmit={saveProprieteProprietaire} className="my-3 px-3">
        <div>
          <label htmlFor="categorie">Catégorie</label>
          <select
            name="transactions"
            id="categorie"
            defaultValue={dataBien.category_libelle}
            onChange={(e) => {
              setDataBien({ ...dataBien, category_libelle: e.target.value });
            }}
            className="w-100 p-3 mb-2">
            <option value={""} disabled>
              Sélectionner une catégorie
            </option>
            {allCategorie.map((item) => (
              <option key={item.id} value={item.label}>
                {item?.label}
              </option>
            ))}
          </select>
        </div>
        {!id && (
          <div>
            <label htmlFor="commune">Propriétaire</label>
            <select
              name="commune"
              id="all_categorie"
              defaultValue={dataBien.proprietaire_id}
              onChange={(e) => {
                setDataBien({ ...dataBien, proprietaire_id: e.target.value });
              }}
              className="w-100 p-3 mb-2">
              <option value="" disabled>
                Sélectionner un propriétaire
              </option>
              {allProprietaire.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.nom} {item.prenom}
                </option>
              ))}
            </select>
          </div>
        )}

        <InputCreate
          label="Bien"
          typeInput="text"
          nameInput="Nom"
          active={true}
          getValue={(e) => {
            setDataBien({ ...dataBien, nom: e.target.value });
          }}
          dataValue={dataBien.nom}
        />

        <div>
          <label htmlFor="type_transaction">Type de transaction</label>
          <select
            name="transactions"
            id="type_transaction"
            defaultValue={dataBien.type_de_transaction}
            onChange={(e) => {
              setDataBien({ ...dataBien, type_de_transaction: e.target.value });
            }}
            className="w-100 p-3 mb-2">
            <option value={""} disabled>
              Sélectionner un type
            </option>
            <option value="EN VENTE">En vente</option>
            <option value="EN LOCATION">En location</option>
          </select>
        </div>
        {dataBien.category_libelle === "Terrain" &&
          dataBien.type_de_transaction === "EN VENTE" && (
            <CreatedTerrain
              dataBien={dataBien}
              setDataBien={setDataBien}
              fileList={fileList}
              onChangeForGalerie={onChangeForGalerie}
              onPreview={onPreview}
              allMunicipalite={allMunicipalite}
              allTypes={allTypes}
            />
          )}
        {dataBien.category_libelle === "Terrain" &&
          dataBien.type_de_transaction === "EN LOCATION" && (
            <h6 className="text-center text-danger">
              Cette option n'est pas encore disponible
            </h6>
          )}
        {dataBien.category_libelle === "Maison" &&
          (dataBien.type_de_transaction === "EN LOCATION" ||
            dataBien.type_de_transaction === "EN VENTE") && (
            <CreateMaison
              dataBien={dataBien}
              setDataBien={setDataBien}
              commodites={commodites}
              setCommodites={setCommodites}
              fileList={fileList}
              onChangeForGalerie={onChangeForGalerie}
              onPreview={onPreview}
              allMunicipalite={allMunicipalite}
              allTypes={allTypes}
            />
          )}

        <div>
          <Button
            titre="Enregistrer"
            styleBtn={styleBtn}
            isLoading={isLoading}
          />
        </div>
      </form> */}
    </div>
  );
}

export default CreateBiens;
